import React from 'react';
import { Box, Typography } from '@mui/material';
import { SportsBaseball } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AtBatExplorerTab } from './Explorer';
import { useYear } from '../context/YearContext';
import useMobile from '../hooks/useMobile';
import PageYearSelector from '../components/common/PageYearSelector';
import { useMemo } from 'react';

const AtBatExplorerPage = () => {
  const theme = useTheme();
  const { year } = useYear();
  const { isMobile } = useMobile();
  const [searchParams] = useSearchParams();

  const deepLinkPlayer = useMemo(() => {
    const team = searchParams.get('team');
    const player = searchParams.get('player');
    if (team && player) return { team, playerName: player };
    return null;
  }, [searchParams]);

  const deepLinkPerspective = searchParams.get('perspective') || 'batter';
  const deepLinkDate = searchParams.get('date') || '';
  const deepLinkVs = searchParams.get('vs') || '';
  const deepLinkInning = searchParams.get('inning') ? parseInt(searchParams.get('inning')) : null;

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 }, maxWidth: 1400, mx: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, flexWrap: 'wrap', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{
            width: 40, height: 40, borderRadius: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
          }}>
            <SportsBaseball sx={{ fontSize: 24, color: '#fff' }} />
          </Box>
          <Typography variant="h5" fontWeight={800} sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' }, lineHeight: 1.2 }}>
            At-Bat Explorer
          </Typography>
        </Box>
        <PageYearSelector />
      </Box>
      <AtBatExplorerTab
        year={year}
        isMobile={isMobile}
        deepLinkPlayer={deepLinkPlayer}
        deepLinkPerspective={deepLinkPerspective}
        deepLinkDate={deepLinkDate}
        deepLinkVs={deepLinkVs}
        deepLinkInning={deepLinkInning}
      />
    </Box>
  );
};

export default AtBatExplorerPage;
